import {FunctionComponent} from 'react';

export type ParagraphProps = {
    size?: 'small' | 'big',
    className?: string
}

const Paragraph: FunctionComponent<ParagraphProps> = (props) => {
    let className = props.size ? ` dfb-Paragraph--${props.size}` : '';
    className += props.className ? ` ${props.className}` : '';

    return (
        <p className={`dfb-Paragraph${className}`}>
            {props.children}
        </p>
    );
};

export default Paragraph;
